export default "__VITE_ASSET__CZgNlgju__"